import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { rateAgreementStateAsString } from "./RateAgreementState";

export const rateAgreementStatusTypeEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={rateAgreementStateAsString} />
);

export const rateAgreementStatusTypeColumnMenu = (props: GridColumnMenuProps) => {
  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      data={[{ Status: "Active" }, { Status: "Pending" }, { Status: "Expired" }]}
      searchBox={() => null}
      {...props}
    />
  );
};
